module.exports = __webpack_public_path__ + "img/logo-belarus.e512719f.svg";